<template>
    <div>
        <h1>It is working.</h1>
        <v-btn
            block
            class="secondary"
            x-large
            @click="APIConnectionCheck"
        >API health check</v-btn>
        <h2>{{ message }}</h2>
    </div>
</template>


<script>
export default {
  name: 'Health',

  data: () => ({
    message: '',
  }),

  methods: {
    APIConnectionCheck() {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/account/health`)
        .then(res => {
            this.message = res.data.message
        })
        .catch(() => {
            this.message = 'APIに接続できませんでした'
        })
    }
  }
};
</script>
